"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _popover_props = require("./popover_props");

var _rcAnimate = _interopRequireDefault(require("rc-animate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var PopOver =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PopOver, _PureComponent);

  function PopOver(props) {
    var _this;

    _classCallCheck(this, PopOver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PopOver).call(this, props));
    _this.popoverRef = null;
    _this.arrowRef = null;
    return _this;
  }

  _createClass(PopOver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setPopOverStyle();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setPopOverStyle();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.arrowRef = null;
      this.popoverRef = null;
    }
  }, {
    key: "compactProps",
    value: function compactProps() {
      var _this$props = this.props,
          leftOfOverlay = _this$props.leftOfOverlay,
          topOfOverlay = _this$props.topOfOverlay,
          positionLeft = _this$props.positionLeft,
          positionTop = _this$props.positionTop;
      return {
        leftOfOverlay: typeof positionLeft !== 'undefined' ? positionLeft : leftOfOverlay,
        topOfOverlay: typeof positionTop !== 'undefined' ? positionTop : topOfOverlay
      };
    } // 获取对应的位置信息

  }, {
    key: "getPositionInfo",
    value: function getPositionInfo() {
      var _this$props2 = this.props,
          positionTarget = _this$props2.positionTarget,
          _this$props2$placemen = _this$props2.placement,
          placement = _this$props2$placemen === void 0 ? '' : _this$props2$placemen;

      var _this$compactProps = this.compactProps(),
          leftOfOverlay = _this$compactProps.leftOfOverlay,
          topOfOverlay = _this$compactProps.topOfOverlay;

      var positionTargetRect = {}; // positionTarget必须是个原生dom

      if (positionTarget && positionTarget.tagName && positionTarget.getBoundingClientRect) {
        positionTargetRect = positionTarget.getBoundingClientRect() || {};
        leftOfOverlay = positionTargetRect.left || positionTargetRect.x;
        topOfOverlay = positionTargetRect.top || positionTargetRect.y;

        if (placement === 'bottom') {
          topOfOverlay += positionTargetRect.height;
        } else if (placement === 'top') {
          topOfOverlay -= positionTargetRect.height; // 减去箭头的高度

          topOfOverlay -= 14;
        } else if (placement === 'left') {
          leftOfOverlay -= positionTargetRect.width; // 减去箭头的宽度

          leftOfOverlay -= 14;
        } else if (placement === 'right') {
          leftOfOverlay += positionTargetRect.width;
        }
      }

      return {
        leftOfOverlay: leftOfOverlay,
        topOfOverlay: topOfOverlay
      };
    }
  }, {
    key: "setPopOverStyle",
    value: function setPopOverStyle() {
      var _this$props3 = this.props,
          placement = _this$props3.placement,
          x = _this$props3.x,
          width = _this$props3.width,
          _this$props3$gap = _this$props3.gap,
          gap = _this$props3$gap === void 0 ? 0 : _this$props3$gap;

      var _this$getPositionInfo = this.getPositionInfo(),
          leftOfOverlay = _this$getPositionInfo.leftOfOverlay,
          topOfOverlay = _this$getPositionInfo.topOfOverlay;

      var popoverTop = topOfOverlay;
      var pageWidth = Math.max(document && document.body && document.body.scrollWidth, window && window.innerWidth);
      var arrowRect = {};
      var popoverRect = {};
      var popoverLeft = leftOfOverlay; // arrowTop = 0,

      var arrowLeft = 0;
      var isReset = false; // offsetTop = -2;

      if (this.popoverRef && this.arrowRef) {
        popoverRect = this.popoverRef.getBoundingClientRect();
        arrowRect = this.arrowRef.getBoundingClientRect(); // arrowTop = popoverRect.top - arrowRect.top - 1;

        arrowLeft = popoverRect.width / 2 - arrowRect.width / 2;

        if (placement === 'top' || placement === 'bottom') {
          if (popoverLeft < gap && popoverLeft > -5000) {
            isReset = true;
            popoverLeft = gap;
          }

          if (popoverLeft + popoverRect.width > pageWidth - gap) {
            isReset = true;
            popoverLeft = pageWidth - 20 - popoverRect.width;
          }

          if (x > popoverLeft) {
            arrowLeft = x - popoverLeft + width / 2;
          }
        }

        if (isReset) {
          // if (className && className.indexOf('dark') > -1) {
          //     offsetTop = 0;
          // }
          // this.arrowRef.style.top = -arrowTop + offsetTop + 'px';
          this.arrowRef.style.left = "".concat(arrowLeft, "px");
          this.popoverRef.style.top = "".concat(popoverTop, "px");
          this.popoverRef.style.left = "".concat(popoverLeft, "px");
        }
      }
    }
  }, {
    key: "getDOMNode",
    value: function getDOMNode() {
      return this.popoverRef || null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          _this$props4$style = _this$props4.style,
          style = _this$props4$style === void 0 ? {} : _this$props4$style,
          title = _this$props4.title,
          children = _this$props4.children,
          placement = _this$props4.placement,
          alignment = _this$props4.alignment,
          onMouseOver = _this$props4.onMouseOver,
          onMouseOut = _this$props4.onMouseOut,
          onClick = _this$props4.onClick,
          show = _this$props4.show,
          _this$props4$arrowSty = _this$props4.arrowStyle,
          arrowStyle = _this$props4$arrowSty === void 0 ? {} : _this$props4$arrowSty,
          hideArrow = _this$props4.hideArrow,
          transitionNameProp = _this$props4.transitionName,
          maxWidth = _this$props4.maxWidth;

      var _this$getPositionInfo2 = this.getPositionInfo(),
          leftOfOverlay = _this$getPositionInfo2.leftOfOverlay,
          topOfOverlay = _this$getPositionInfo2.topOfOverlay;

      var cssText = (0, _spauiUtils.objectAssign)({
        display: 'block',
        maxWidth: maxWidth
      }, style, {
        left: "".concat(leftOfOverlay, "px"),
        top: "".concat(topOfOverlay, "px")
      }); // 20250409 yijie: 这里判断 transitionNameProp 是否为默认，如果是则根据 hideArrow 设置不同的 transition 表现

      var transitionName = transitionNameProp;

      if (transitionNameProp === _popover_props.defaultProps.transitionName) {
        transitionName = hideArrow ? 'spaui-popover-hide-arrow' : 'spaui-popover';
      }

      return _react["default"].createElement(_rcAnimate["default"], {
        transitionName: transitionName,
        component: ""
      }, show ? _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-popover', placement, _defineProperty({
          'hide-arrow': hideArrow
        }, "spaui-popover-".concat(placement, "-").concat(alignment), alignment))
      }, PopOver, this.props), {
        style: cssText,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onClick: onClick,
        ref: function ref(el) {
          _this2.popoverRef = el;
        }
      }), _react["default"].createElement("div", {
        className: "spaui-popover-offset"
      }), _react["default"].createElement("div", {
        className: "spaui-popover-arrow",
        style: arrowStyle,
        ref: function ref(el) {
          _this2.arrowRef = el;
        }
      }), title ? _react["default"].createElement("div", {
        className: "spaui-popover-title"
      }, title) : null, _react["default"].createElement("div", {
        className: "spaui-popover-content"
      }, children)) : null);
    }
  }]);

  return PopOver;
}(_react.PureComponent); // 组件标记


_defineProperty(PopOver, "propTypes", _popover_props.propTypes);

_defineProperty(PopOver, "defaultProps", _popover_props.defaultProps);

(0, _spauiUtils.setComponentMark)(PopOver, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = PopOver;
exports["default"] = _default;